import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'beta.300',
    endColor: 'beta.400',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'leagueEventsInput',
    mx: ['2', null, 'unset'],
    sxWrapper: {
      mb: '0',
      '.chakra-input': {
        bg: 'blackAlpha.600',
        border: '1px',
        borderColor: 'none',
        boxShadow: 'lg',
        borderRadius: 'md',
        mb: '0',
      },
    },
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
    _hover: {
      borderColor: 'alpha.500',
      bg: 'blackAlpha.600',
    },
    _focus: {
      boxShadow: 'xl',
      borderColor: 'alpha.500',
      color: 'alpha.500',
      textShadow: 'sm',
      bg: 'blackAlpha.700',
    },
  },
  inputRightIcon: {
    color: 'alpha.500',
    boxSize: '4',
    as: Search,
    mr: ['2', null, 'unset'],
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
    mx: ['2', null, 'unset'],
    w: ['97.5%', null, '100%'],
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'beta.500',
    fontSize: 'sm',
    sx: {},
  },
  accordionButtonText: {
    fontSize: ['sm', 'md'],
    fontWeight: 'medium',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '3.5',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: 'xs',
    fontWeight: 'medium',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'beta.500',
    sx: {},
  },
  accordionPanel: {
    p: '0',
    mb: '3',
    m: ['2', null, 'unset'],
  },
};
